import React from 'react';
import {MatchPropsInterface} from './matchInterface';

const Winner = ({match}: MatchPropsInterface): React.ReactNode => <div className="winner">
    <span title={match?.player_one}>{match ? match.player_one : ''}</span>
</div>;

export default Winner;
